import { render, staticRenderFns } from "./ReserverForm.vue?vue&type=template&id=6084a152"
import script from "./ReserverForm.vue?vue&type=script&lang=ts"
export * from "./ReserverForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports